import type { KeyboardEvent } from 'react';

type WizardToggleTileButtonProps = {
  selected: boolean;
  label: string;
  onToggle: () => void;
  ariaLabel: string;
};

export const WizardToggleTileButton = ({
  selected,
  label,
  onToggle,
  ariaLabel,
}: WizardToggleTileButtonProps) => {
  const handleKeyDown = (e: KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onToggle();
    }
  };

  return (
    <button
      type="button"
      onClick={onToggle}
      onKeyDown={handleKeyDown}
      tabIndex={0}
      aria-pressed={selected}
      aria-label={ariaLabel}
      className={[
        'relative flex min-h-[4.5rem] flex-1 items-center justify-center rounded-2xl px-2 py-4 text-base font-bold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/50',
        selected
          ? 'border-2 border-primary-600 bg-green-50 text-gray-900 dark:border-emerald-500 dark:bg-emerald-950/35 dark:text-gray-100'
          : 'border border-gray-300 bg-white text-gray-700 hover:border-gray-400 dark:border-gray-600 dark:bg-gray-900 dark:text-gray-200 dark:hover:border-gray-500',
      ].join(' ')}
    >
      <span>{label}</span>
      {selected ? (
        <span
          className="absolute bottom-2 right-2 flex h-4 w-4 items-center justify-center text-primary-600 dark:text-emerald-400"
          aria-hidden
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
          </svg>
        </span>
      ) : null}
    </button>
  );
};
